import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const pagePermissionsTemplateApi = {
  // GET
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pagePermissionsTemplate`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getActions: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pagePermissionsTemplate/actions`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getViews: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/pagePermissionsTemplate/views`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // PUT
  updateUserPagePermissions: async (userId, data) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/pagePermissionsTemplate/updateUserPagePermissions/${userId}`, {
        data,
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  addMissingPermission: async (data: {
    pageName: string;
    permissionType: 'action' | 'view';
    permissionName: string;
  }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/pagePermissionsTemplate/missingPermission`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  addMissingTemplate: async (data: { pageName: string }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/pagePermissionsTemplate/missingTemplate`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  updateTemplate: async (
    templateId: string,
    data: {
      category?: string | null;
      pageName?: string;
      pageTitle?: string;
      pageTitleEs?: string;
      removeActionIds?: string[];
      removeViewIds?: string[];
    }
  ) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/pagePermissionsTemplate/${templateId}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  deleteTemplate: async (templateId: string) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/pagePermissionsTemplate/${templateId}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default pagePermissionsTemplateApi;
